export const SectionEyebrow = ({ children, className = "" }) => (
    <div className={`flex items-center gap-3 ${className}`}>
        <span className="h-px w-8 bg-brand-green" />
        <span className="label-eyebrow">{children}</span>
    </div>
);
